/**
 * HMService — STUB v1.12.485 (RapidAPI désactivé)
 */
export async function getHMProducts() { return []; }
